import React from 'react';
import { Link } from 'react-router-dom';
import { MeatballMenu, PromptConfirmationModal } from 'ui';
import { routeConstants } from 'app/routes/route-constants';
import { ListItemProps } from 'app/area/experience-transfer/list/types-store';
import { CodetableItemLoader } from 'app/area/shared/codetable/item/codetable-item-loader';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { Tooltip } from 'ui/common/tooltip/tooltip';
import { MdInfo } from 'node_modules/react-icons/md';
import { Tag } from 'app/components/tag';
import { isDisabled } from 'app/infrastructure/data/date';
import styles from './list-item.scss';

export const ListItem: React.FC<ListItemProps> = ({
  item, deleting, translation, deleteExperienceTransfer
}) => {

  const handleDelete = () => {
    deleteExperienceTransfer(
      item.id,
      item.subscriberGroupDescription,
      translation.experience_transfer_deleted
    );
  };

  const isInactive = !item?.active || isDisabled(item.subscriberGroupDisabled);

  return <div className={styles.experienceTransferRow}>
    <Link
      className={`${styles.container} ${deleting ? styles.disabled : ''}`}
      to={routeConstants.experienceTransferEditFor(item.id)}>
      <div className={styles.content}>
        <div className={styles.leftSide}>
          <div className={`${styles.leftSideColumn} ${styles.wider}`}>
            <div className={styles.defaultColumn}>
              {item.subscriberGroupDescription} <div className="d-inline-block">
                {deleting && <CodetableItemLoader />}
              </div>
            </div>
          </div>
          <div className={`${styles.leftSideColumn} ${styles.wider}`}>
            {item.criteriaDescription} {item.criteriaLongDescription
              ? <Tooltip
                title={item.criteriaLongDescription}
                center={true}
                wide={true}>
                <MdInfo />
              </Tooltip>
              : null}
          </div>
          <div className={styles.leftSideColumn}>
            {item.caseTypeDescription}
          </div>
          <div className={styles.leftSideColumn}>
            {item.operationDescription}
          </div>
          <div className={styles.leftSideColumn}>
            {isInactive
              ? <Tag className="pull-right">
                {translation.inactive}
              </Tag> : null}
          </div>
        </div>
      </div>
    </Link>
    {item.id !== 0 && !deleting
      ? <MeatballMenu
        id={`meatball-${item.id}`}
        className={styles.meatball}>
        <li>
          <PromptConfirmationModal
            title={translation.delete_experience_transfer}
            description={replaceTemplateString(
              translation.delete_confirmation,
              item?.id,
              [
                item?.subscriberGroupDescription ?? '',
                item?.criteriaDescription ?? '',
                item?.caseTypeDescription ?? '',
                item?.operationDescription ?? '',
                (isInactive ? translation.inactive : '')
              ].filter(Boolean).join(' | ')
            )}
            continueText={translation.delete}
            cancelText={translation.cancel}
            onContinue={handleDelete}>
            <button type="button"
              className="dropdown-item"
              disabled={deleting}>
              {translation.delete}
            </button>
          </PromptConfirmationModal>
        </li>
      </MeatballMenu> : null}
  </div>;
};
